import urls from '../constants/urls'

import {
  checkIfErrorCodePresent
} from '../utils/errorHandling'

export const CONFIRMATION_FAILED = 'confirmation/CONFIRMATION_FAILED'
export const CONFIRMATION_SUCCESS = 'confirmation/CONFIRMATION_SUCCESS'
export const CONFIRMING = 'confirmation/CONFIRMING'

export const CONFIRMATION_CODE_REQUEST_FAILED_GENERIC = 'confirmation/CONFIRMATION_CODE_REQUEST_FAILED_GENERIC'
export const CONFIRMATION_CODE_REQUEST_FAILED_NOT_FOUND = 'confirmation/CONFIRMATION_CODE_REQUEST_FAILED_NOT_FOUND'
export const CONFIRMATION_CODE_REQUEST_FAILED_ALREADY_CONFIRMED = 'confirmation/CONFIRMATION_CODE_REQUEST_FAILED_ALREADY_CONFIRMED'
export const CONFIRMATION_CODE_REQUEST_FAILED = 'confirmation/CONFIRMATION_CODE_REQUEST_FAILED'
export const CONFIRMATION_CODE_REQUEST_SUCCESS = 'confirmation/CONFIRMATION_CODE_REQUEST_SUCCESS'
export const REQUESTING_CONFIRMATION_CODE = 'confirmation/REQUESTING_CONFIRMATION_CODE'

const initialState = {
  failedConfirmation: false,
  failedRequest:      false,

  isConfirming: false,
  isRequesting: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CONFIRMING:
      return {
        ...state,
        failedConfirmation: false,
        isConfirming:       true
      }

    case CONFIRMATION_SUCCESS:
      return {
        ...state,
        isConfirming: false
      }

    case CONFIRMATION_FAILED:
      return {
        ...state,
        failedConfirmation: true,
        isConfirming:       false
      }

    case REQUESTING_CONFIRMATION_CODE:
      return {
        ...state,
        failedRequest: false,
        isRequesting:  true
      }

    case CONFIRMATION_CODE_REQUEST_SUCCESS:
      return {
        ...state,
        isRequesting: false
      }

    case CONFIRMATION_CODE_REQUEST_FAILED:
      return {
        ...state,
        failedRequest: true,
        isRequesting:  false
      }

    default:
      return state
  }
}

export const confirmUser = (confirmationToken) => (dispatch) => {
  return dispatch({
    types:   [CONFIRMING, CONFIRMATION_SUCCESS, CONFIRMATION_FAILED],
    payload: {
      request: {
        method: 'patch',
        url:    urls.confirmation.confirm(confirmationToken)
      }
    }
  })
}

export const requestConfirmationToken = (params) => (dispatch) => {
  let onErrorDispatch = ({ error }) => {
    if (checkIfErrorCodePresent(error, 'user_not_found')) {
      dispatch({ type: CONFIRMATION_CODE_REQUEST_FAILED_NOT_FOUND })
    } else if (checkIfErrorCodePresent(error, 'user_already_confirmed')) {
      dispatch({ type: CONFIRMATION_CODE_REQUEST_FAILED_ALREADY_CONFIRMED })
    } else {
      dispatch({ type: CONFIRMATION_CODE_REQUEST_FAILED_GENERIC })
    }
  }

  let promise = dispatch({
    types:   [REQUESTING_CONFIRMATION_CODE, CONFIRMATION_CODE_REQUEST_SUCCESS, CONFIRMATION_CODE_REQUEST_FAILED],
    payload: {
      request: {
        method: 'post',
        url:    urls.confirmation.request,
        data:   {
          email: params.email
        }
      }
    }
  })

  promise.catch(onErrorDispatch)

  return promise
}
